export default __webpack_public_path__ + "static/media/yuma.8c01689e.png";